// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../b2b/(B2bOrganization)/ManagerInfo";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        organizationId: "0",
        managerInfo: undefined,
        name: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.organizationId !== undefined)
        result.organizationId = tsValueToJsonValueFns.int64(value.organizationId);
    if (value.managerInfo !== undefined)
        result.managerInfo = encodeJson_1(value.managerInfo);
    if (value.name !== undefined)
        result.name = tsValueToJsonValueFns.string(value.name);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.organizationId !== undefined)
        result.organizationId = jsonValueToTsValueFns.int64(value.organizationId);
    if (value.managerInfo !== undefined)
        result.managerInfo = decodeJson_1(value.managerInfo);
    if (value.name !== undefined)
        result.name = jsonValueToTsValueFns.string(value.name);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.organizationId !== undefined) {
        const tsValue = value.organizationId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.managerInfo !== undefined) {
        const tsValue = value.managerInfo;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.name !== undefined) {
        const tsValue = value.name;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.organizationId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.managerInfo = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.name = value;
    }
    return result;
}
